<app-countdown [endDate]="endDate" (updated)="onUpdate()" class="subscription-countdown" [class]="getColor()" />
